import { ClassEnum, DISPLAY_TYPE_OPTIONS, HeaderRadioDirection, SETTING_TYPE } from '@/constants/enum';
import { getColor } from '@/helpers';
import { handleSavePreviewOptionSettings, previewOptionSelector } from '@/redux/slice/preview.slice';
import { widgetColorSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { useDispatch, useSelector } from 'react-redux';
import { StyledHeaderRadioLabel } from '../../styled/element-styled';
import RadioInput from './RadioInput';

export interface IHeaderOption {
  value: SETTING_TYPE;
  label?: string;
  icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}

interface IProps {
  direction: HeaderRadioDirection;
  options: IHeaderOption[];
}

const HeaderRadio = ({ direction, options }: IProps) => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const widgetColors = useSelector(widgetColorSelector);
  const previewOptions = useSelector(previewOptionSelector);
  const dispatch = useDispatch();

  return (
    <div>
      <div className={`${ClassEnum.HeaderRadio} ${ClassEnum.HeaderRadio + '-' + direction}`}>
        {options.map((option) => {
          const isChecked = previewOptions.methods.find((item) => item.selected)?.key === option.value;
          return (
            <div
              key={option.value}
              style={{
                width: direction === HeaderRadioDirection.VERTICAL ? '100%' : `calc(100% / ${options.length})`,
              }}
            >
              <StyledHeaderRadioLabel
                className={`${ClassEnum.HeaderRadioLabel} ${isChecked ? 'checked' : ''}`}
                color={
                  isChecked
                    ? getColor(widgetSettings.colorScheme, widgetColors, 'header', 'selectedButtonColor')
                    : getColor(widgetSettings.colorScheme, widgetColors, 'header', 'buttonColor')
                }
                fontWeight={isChecked ? 600 : 500}
                backgroundColor={
                  isChecked
                    ? getColor(widgetSettings.colorScheme, widgetColors, 'header', 'selectedButtonBackground')
                    : getColor(widgetSettings.colorScheme, widgetColors, 'header', 'buttonBackground')
                }
                borderColor={
                  isChecked
                    ? getColor(widgetSettings.colorScheme, widgetColors, 'header', 'selectedButtonBorder')
                    : getColor(widgetSettings.colorScheme, widgetColors, 'header', 'buttonBorder')
                }
                borderRadius={widgetSettings.widgetMethods.borderRadius}
                flexDirection={
                  direction === HeaderRadioDirection.VERTICAL
                    ? widgetSettings.widgetMethods.hideCheckIcon
                      ? 'row'
                      : 'row-reverse'
                    : 'column'
                }
                justifyContent={direction === HeaderRadioDirection.VERTICAL ? 'space-between' : ''}
                hoverBackgroundColor={getColor(widgetSettings.colorScheme, widgetColors, 'header', 'hoverButtonBackground')}
                colorHover={getColor(widgetSettings.colorScheme, widgetColors, 'header', 'hoverButtonColor')}
                borderColorHover={getColor(widgetSettings.colorScheme, widgetColors, 'header', 'hoverButtonBorder')}
                fontSize={widgetSettings.sizes.labelFontSize}
                isChecked={isChecked}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(
                    handleSavePreviewOptionSettings({
                      methods: previewOptions.methods.map((method) =>
                        method.key === option.value ? { ...method, selected: true } : { ...method, selected: false },
                      ),
                    }),
                  );
                }}
              >
                {!widgetSettings.widgetMethods.hideCheckIcon ? <RadioInput isChecked={isChecked} /> : null}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: direction === 'vertical' ? 'row' : 'column',
                    gap: direction === 'vertical' ? 8 : 4,
                  }}
                >
                  {widgetSettings.widgetMethods.displayType !== DISPLAY_TYPE_OPTIONS.TEXT && (
                    <option.icon
                      style={{
                        width: (24 * widgetSettings.sizes.labelFontSize) / 14,
                        height: (24 * widgetSettings.sizes.labelFontSize) / 14,
                      }}
                      fill={getColor(widgetSettings.colorScheme, widgetColors, 'header', 'buttonColor')}
                    />
                  )}
                  <div className={ClassEnum.HeaderRadioLabelText}>
                    {widgetSettings.widgetMethods.displayType !== DISPLAY_TYPE_OPTIONS.ICON ? option.label : null}
                  </div>
                </div>
              </StyledHeaderRadioLabel>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HeaderRadio;
